import React from 'react';
export function Footer() {
  return <footer className="bg-gray-50 border-t border-gray-200" data-id="element-232">
      <div className="container mx-auto px-4 sm:px-6 lg:px-8 py-16" data-id="element-233">
        <div className="grid grid-cols-2 md:grid-cols-4 lg:grid-cols-5 gap-8" data-id="element-234">
          <div className="col-span-2 lg:col-span-1" data-id="element-235">
            <a href="/" className="flex items-center mb-4" data-id="element-236">
              <img src="https://uploadthingy.s3.us-west-1.amazonaws.com/kRc7rhjFDU8iYC6REbd6XF/Logo_Green_horizontal.png" alt="Nexio Logo" className="h-48 w-auto" data-id="element-237" />
            </a>
            <p className="text-gray-600 mb-4 mt-2" data-id="element-238">
              Empowering community collaboration in education.
            </p>
            <div className="flex space-x-4" data-id="element-239">
              <a href="#" className="text-gray-400 hover:text-[#00A862]" data-id="element-240">
                <svg className="h-5 w-5" fill="currentColor" viewBox="0 0 24 24" data-id="element-241">
                  <path d="M24 4.557c-.883.392-1.832.656-2.828.775 1.017-.609 1.798-1.574 2.165-2.724-.951.564-2.005.974-3.127 1.195-.897-.957-2.178-1.555-3.594-1.555-3.179 0-5.515 2.966-4.797 6.045-4.091-.205-7.719-2.165-10.148-5.144-1.29 2.213-.669 5.108 1.523 6.574-.806-.026-1.566-.247-2.229-.616-.054 2.281 1.581 4.415 3.949 4.89-.693.188-1.452.232-2.224.084.626 1.956 2.444 3.379 4.6 3.419-2.07 1.623-4.678 2.348-7.29 2.04 2.179 1.397 4.768 2.212 7.548 2.212 9.142 0 14.307-7.721 13.995-14.646.962-.695 1.797-1.562 2.457-2.549z" data-id="element-242" />
                </svg>
              </a>
              <a href="#" className="text-gray-400 hover:text-[#00A862]" data-id="element-243">
                <svg className="h-5 w-5" fill="currentColor" viewBox="0 0 24 24" data-id="element-244">
                  <path d="M12 0c-6.626 0-12 5.373-12 12 0 5.302 3.438 9.8 8.207 11.387.599.111.793-.261.793-.577v-2.234c-3.338.726-4.033-1.416-4.033-1.416-.546-1.387-1.333-1.756-1.333-1.756-1.089-.745.083-.729.083-.729 1.205.084 1.839 1.237 1.839 1.237 1.07 1.834 2.807 1.304 3.492.997.107-.775.418-1.305.762-1.604-2.665-.305-5.467-1.334-5.467-5.931 0-1.311.469-2.381 1.236-3.221-.124-.303-.535-1.524.117-3.176 0 0 1.008-.322 3.301 1.23.957-.266 1.983-.399 3.003-.404 1.02.005 2.047.138 3.006.404 2.291-1.552 3.297-1.23 3.297-1.23.653 1.653.242 2.874.118 3.176.77.84 1.235 1.911 1.235 3.221 0 4.609-2.807 5.624-5.479 5.921.43.372.823 1.102.823 2.222v3.293c0 .319.192.694.801.576 4.765-1.589 8.199-6.086 8.199-11.386 0-6.627-5.373-12-12-12z" data-id="element-245" />
                </svg>
              </a>
              <a href="#" className="text-gray-400 hover:text-[#00A862]" data-id="element-246">
                <svg className="h-5 w-5" fill="currentColor" viewBox="0 0 24 24" data-id="element-247">
                  <path d="M22.675 0h-21.35c-.732 0-1.325.593-1.325 1.325v21.351c0 .731.593 1.324 1.325 1.324h11.495v-9.294h-3.128v-3.622h3.128v-2.671c0-3.1 1.893-4.788 4.659-4.788 1.325 0 2.463.099 2.795.143v3.24l-1.918.001c-1.504 0-1.795.715-1.795 1.763v2.313h3.587l-.467 3.622h-3.12v9.293h6.116c.73 0 1.323-.593 1.323-1.325v-21.35c0-.732-.593-1.325-1.325-1.325z" data-id="element-248" />
                </svg>
              </a>
              <a href="#" className="text-gray-400 hover:text-[#00A862]" data-id="element-249">
                <svg className="h-5 w-5" fill="currentColor" viewBox="0 0 24 24" data-id="element-250">
                  <path d="M19.615 3.184c-3.604-.246-11.631-.245-15.23 0-3.897.266-4.356 2.62-4.385 8.816.029 6.185.484 8.549 4.385 8.816 3.6.245 11.626.246 15.23 0 3.897-.266 4.356-2.62 4.385-8.816-.029-6.185-.484-8.549-4.385-8.816zm-10.615 12.816v-8l8 3.993-8 4.007z" data-id="element-251" />
                </svg>
              </a>
            </div>
          </div>
          <div data-id="element-252">
            <h3 className="font-semibold text-gray-900 mb-4" data-id="element-253">Product</h3>
            <ul className="space-y-2" data-id="element-254">
              <li data-id="element-255">
                <a href="#" className="text-gray-600 hover:text-[#00A862]" data-id="element-256">
                  Features
                </a>
              </li>
              <li data-id="element-257">
                <a href="#" className="text-gray-600 hover:text-[#00A862]" data-id="element-258">
                  Pricing
                </a>
              </li>
              <li data-id="element-259">
                <a href="#" className="text-gray-600 hover:text-[#00A862]" data-id="element-260">
                  Security
                </a>
              </li>
              <li data-id="element-261">
                <a href="#" className="text-gray-600 hover:text-[#00A862]" data-id="element-262">
                  Roadmap
                </a>
              </li>
            </ul>
          </div>
          <div data-id="element-263">
            <h3 className="font-semibold text-gray-900 mb-4" data-id="element-264">Resources</h3>
            <ul className="space-y-2" data-id="element-265">
              <li data-id="element-266">
                <a href="#" className="text-gray-600 hover:text-[#00A862]" data-id="element-267">
                  Documentation
                </a>
              </li>
              <li data-id="element-268"></li>
              <li data-id="element-269">
                <a href="#" className="text-gray-600 hover:text-[#00A862]" data-id="element-270">
                  API (coming soon)
                </a>
              </li>
              <li data-id="element-271">
                <a href="#" className="text-gray-600 hover:text-[#00A862]" data-id="element-272">
                  Community
                </a>
              </li>
            </ul>
          </div>
          <div data-id="element-273">
            <h3 className="font-semibold text-gray-900 mb-4" data-id="element-274">Company</h3>
            <ul className="space-y-2" data-id="element-275">
              <li data-id="element-276">
                <a href="#" className="text-gray-600 hover:text-[#00A862]" data-id="element-277">
                  About
                </a>
              </li>
              <li data-id="element-278">
                <a href="#" className="text-gray-600 hover:text-[#00A862]" data-id="element-279">
                  Become an Affiliate
                </a>
              </li>
              <li data-id="element-280">
                <a href="#" className="text-gray-600 hover:text-[#00A862]" data-id="element-281">
                  Contact
                </a>
              </li>
            </ul>
          </div>
          <div data-id="element-282">
            <h3 className="font-semibold text-gray-900 mb-4" data-id="element-283">Legal</h3>
            <ul className="space-y-2" data-id="element-284">
              <li data-id="element-285">
                <a href="/privacy" className="text-gray-600 hover:text-[#00A862]" data-id="element-286">
                  Privacy
                </a>
              </li>
              <li data-id="element-287">
                <a href="/terms" className="text-gray-600 hover:text-[#00A862]" data-id="element-288">
                  Terms
                </a>
              </li>
              <li data-id="element-289">
                <a href="/cookie-policy" className="text-gray-600 hover:text-[#00A862]" data-id="element-290">
                  Cookie Policy
                </a>
              </li>
            </ul>
          </div>
        </div>
        <div className="mt-12 pt-8 border-t border-gray-200 text-center" data-id="element-291">
          <p className="text-gray-500 text-sm bg-white inline-block px-6 py-2 rounded-lg shadow-sm border border-gray-100" data-id="element-292">
            &copy; {new Date().getFullYear()} Nexio App. All rights reserved.
          </p>
        </div>
      </div>
    </footer>;
}